import { CvCResultFileInfo, sourceFileListModel } from '@/stores/cvc';
import { sourceUploadingStatesModel } from '@/stores/resource';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useSetRecoilState } from 'recoil';

import useConfirmModal from './useConfirmModal';

const useAsSource = () => {
  const sourceList = useRecoilValue(sourceFileListModel);
  const setSourceList = useSetRecoilState(sourceFileListModel);
  const setSourceUploadingStates = useSetRecoilState(
    sourceUploadingStatesModel
  );
  const { openConfirmModal } = useConfirmModal();
  const { t } = useTranslation();
  return useCallback(
    (item: CvCResultFileInfo) => {
      if (!sourceList.find((source) => source.id === item.resource_id)) {
        setSourceList((prev) => [
          {
            ...item,
            id: item.resource_id as string,
            isSource: true,
            isChecked: true,
          },
          ...prev,
        ]);
        setSourceUploadingStates((prev) => {
          return { ...prev, [item.resource_id as string]: 'COMPLETE' };
        });
      } else {
        // Acknowledgement through the app-wide confirm modal channel the
        // CVC page already mounts — no native dialog, no second modal
        // channel (ISSUE-009).
        openConfirmModal({
          message: t('This file has already been added'),
          confirmText: t('OK') as string,
          hideCancel: true,
        });
      }
    },
    [sourceList, setSourceList, setSourceUploadingStates, openConfirmModal, t]
  );
};
export default useAsSource;
